import { connect } from 'react-redux';
import Booking from 'pages/Booking';
import toMomentObject from 'react-dates/lib/utils/toMomentObject';
import toISODateString from 'react-dates/lib/utils/toISODateString';
import { bookingSubmit, getPaymentTokenAction, bookingSubmitAction, updateActiveListing, resetBooking } from 'listing/listing.actions';
import { getEmail } from 'website/website.selectors';

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const {
    listings: { query, results, activeListing, booked, booking },
    website: { title, paymentProcessing, color, ui: { winWidth } }
  } = state;
  const listing = activeListing || results[id];
  const email = getEmail(state);

  return {
    pageTitle: title,
    startDate: toMomentObject(query.startDate),
    endDate: toMomentObject(query.endDate),
    listing,
    guests: query.guests,
    isCreditCard: !!paymentProcessing,
    booked,
    booking,
    color,
    email,
    isTotalCollapsed: winWidth < 768
  }
};

const mapDispatchToProps = dispatch => {
  return {
    updateActiveListing: listingId => dispatch(updateActiveListing(listingId)),

    onSubmit: ({ listingId, startDate, endDate, guestsCount, cardNumber, cvc, expiration, firstName, lastName, email, phone, message }) => {
      const checkInDateLocalized = toISODateString(startDate);
      const checkOutDateLocalized = toISODateString(endDate);
      const bookingData = {
        "reservation": {
          listingId,
          checkInDateLocalized,
          checkOutDateLocalized,
          guestsCount,
          "source": "website",
          "sourceNotes": {
            "websiteSource": "DIRECT",
            "websiteReferrer": ""
          }
        },
        "guest": {
          firstName,
          lastName,
          email,
          phone
        },
        message
      };

      if (cardNumber) {
        const cardData = {
          cardNumber,
          cvc,
          expiration
        };

        dispatch(getPaymentTokenAction(cardData))
          .then(token => dispatch(bookingSubmit({ ...bookingData, payment: { token } })))
          .catch(err => dispatch(bookingSubmitAction({ err })))
      } else {
        dispatch(bookingSubmit(bookingData))
      }
    },

    resetBooking: () => dispatch(resetBooking())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Booking);


// WEBPACK FOOTER //
// ./src/containers/Booking.container.js